import { Job } from '~hooks/useJob/models';
import JobThreadPanel from '~pages/Dispatch/components/JobMessaging/JobThreadPanel';

type JobMessagingTabProps = {
  job: Job;
  readOnly?: boolean;
};

export default function JobMessagingTab({ job, readOnly }: JobMessagingTabProps) {
  const jobContext = [job.jobId, job.order?.orderId, job.material?.name]
    .filter(Boolean)
    .join(' · ');

  return (
    <JobThreadPanel
      canStartConversation={job.messagingEnabled}
      driverAvatarColorKey={job.driver?.id ?? job.id}
      driverName={job.driverFullName}
      jobContext={jobContext}
      jobId={job.id}
      jobLabel={job.jobId}
      readOnly={readOnly}
    />
  );
}
